import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { KineticHero } from "@/components/landing/KineticHero";
import { Marquee } from "@/components/landing/Marquee";
import { Fleet } from "@/components/landing/Fleet";
import { RoutesSection } from "@/components/landing/RoutesSection";
import { Tours } from "@/components/landing/Tours";
import { Manifesto } from "@/components/landing/Manifesto";
import { Testimonials } from "@/components/landing/Testimonials";
import { ServiceAreas } from "@/components/landing/ServiceAreas";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingButtons } from "@/components/landing/FloatingButtons";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.lenis = lenis;
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Smooth-scroll for in-page anchor links.
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <KineticHero />
        <Marquee />
        <Fleet />
        <RoutesSection />
        <Tours />
        <Manifesto />
        <Testimonials />
        <ServiceAreas />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
